import React, { memo } from "react";
import "./CustomSpinner.less";

function CustomSpinner() {
    return <div className="lds-dual-ring">&nbsp;</div>;
}

export default memo(CustomSpinner);

